export function authorAccordion() {
	const wrapper = document.getElementById('accordion_1');
	if (!wrapper) return;

	const buttons = wrapper.querySelectorAll('[data-toggle="content_button"]');
	const rightPanel = wrapper.querySelector('.accordion_right');
	const breakpoint = 1024;

	function deactivateAll() {
		buttons.forEach((btn) => {
			btn.classList.remove('active');
			const content = btn.nextElementSibling;
			if (content && content.classList.contains('accordion_content')) {
				content.style.display = 'none';
			}
		});
	}

	function showInRightPanel(content) {
		if (!rightPanel) return;
		rightPanel.style.opacity = '0';
		rightPanel.style.transition = 'opacity 0.25s ease';

		setTimeout(() => {
			rightPanel.innerHTML = content.innerHTML;
			const inner = rightPanel.querySelector('.accordion_content');
			if (inner) inner.style.display = 'block';
			rightPanel.style.opacity = '1';
		}, 250);
	}

	function handleClick(e) {
		const btn = e.currentTarget;
		const content = btn.nextElementSibling;
		if (!content || !content.classList.contains('accordion_content')) return;

		const isMobile = window.innerWidth <= breakpoint;

		if (isMobile) {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				slideUp(content);
			} else {
				buttons.forEach((b) => {
					b.classList.remove('active');
					const c = b.nextElementSibling;
					if (c && c.classList.contains('accordion_content') && c !== content) {
						slideUp(c);
					}
				});
				btn.classList.add('active');
				slideDown(content);
			}
		} else {
			if (btn.classList.contains('active')) return;
			deactivateAll();
			btn.classList.add('active');
			showInRightPanel(content);
		}
	}

	buttons.forEach((btn) => btn.addEventListener('click', handleClick));

	// Auto-open first item
	if (buttons.length > 0) {
		buttons[0].click();
	}
}

function slideDown(el) {
	el.style.display = 'block';
	el.style.overflow = 'hidden';
	el.style.height = '0';
	el.style.transition = 'height 0.3s ease';
	const h = el.scrollHeight + 'px';
	requestAnimationFrame(() => {
		el.style.height = h;
	});
	el.addEventListener(
		'transitionend',
		() => {
			el.style.height = '';
			el.style.overflow = '';
			el.style.transition = '';
		},
		{ once: true }
	);
}

function slideUp(el) {
	el.style.overflow = 'hidden';
	el.style.height = el.scrollHeight + 'px';
	el.style.transition = 'height 0.3s ease';
	requestAnimationFrame(() => {
		el.style.height = '0';
	});
	el.addEventListener(
		'transitionend',
		() => {
			el.style.display = 'none';
			el.style.height = '';
			el.style.overflow = '';
			el.style.transition = '';
		},
		{ once: true }
	);
}
